import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Util from '../../../utils/utils';

const VerifyError = () => {
    const [redirectUrl, setRedirectUrl] = useState('')
    const [merchantName, setMerchantName] = useState("") 
    const [returnMessage, setReturnMessage] = useState('')
    const [returnCode, setReturnCode] = useState('')
    const location = useLocation();

    useEffect(() => {
        document.title = 'Authorization Page';
        const params = location.state;
        if (!params) return;
        let bindingInfo = params.binding_info
        const mcInfo = Util.getMerchantInfo(bindingInfo);
        setMerchantName(mcInfo.merchant_name)
        setReturnCode(params.return_code)
        setReturnMessage(params.return_message)
        if(bindingInfo.app_id)
          setRedirectUrl(bindingInfo.redirect_url +'?app_id=' + bindingInfo.app_id + "&binding_token=" + bindingInfo.binding_token )

    }, []);

    const handlePickPrevious = () => {
        if(redirectUrl !== "")
        window.location.href = redirectUrl;
    }

    return (
        <div className="zpbiding">

            <header id="header" hidden={true}>
                <div className="previous-page">
                    <a href="#"><img src="/img/default.svg" alt="arrow back"/></a>
                </div>
                <div className="title-page">{merchantName}</div>
                <div className="action-page"></div>
            </header>

            <div id="body-biding-status">

                <div className="top-status">
                    <p className="art-illus">
                        <img src="/img/error.svg" alt="error"/>
                    </p>
                    <h2 className="title-status">
                        Liên kết thất bại tài khoản<br/>Zalopay với {merchantName}
                    </h2>
                </div>
                <div className="bottom-status">
                    <div className="link-service">
                        <h2>Mã lỗi {returnCode}</h2>
                        <p>{returnMessage}</p>
                    </div>
                </div>
                <div className="space"></div>
                <button className="btn btn-continue" onClick={handlePickPrevious}>Thực hiện lại</button>

            </div>

        </div>
    );
};

export default VerifyError;